// Translation dictionary for ES (default) and EN.
export const dict = {
  es: {
    appName: "Iglesia Nueva Cancion",
    languageName: "Espanol",
    switchTo: "English",
    tagline: "Una familia, una fe, una nueva cancion",
    nav: {
      home: "Inicio",
      events: "Eventos",
      give: "Ofrendar",
      prayer: "Oracion",
      social: "Social",
      gallery: "Galeria",
    },
    register: {
      title: "Bienvenido a casa",
      subtitle: "Antes de comenzar, registrate como parte de nuestra familia.",
      fullName: "Nombre completo",
      dob: "Fecha de nacimiento",
      phone: "Numero de telefono",
      maritalStatus: "Estado civil",
      ms: { single: "Soltero(a)", married: "Casado(a)", divorced: "Divorciado(a)", widowed: "Viudo(a)" },
      anniversary: "Aniversario de boda",
      submit: "Registrarme",
      submitting: "Registrando...",
      privacy: "Tus datos se mantienen privados y solo seran vistos por el equipo pastoral.",
      success: "Registro completado. \u00a1Bienvenido!",
      requiredAll: "Por favor completa todos los campos requeridos.",
      alreadyRegistered: "\u00bfYa te registraste antes?",
      lookupLink: "Recuperar mi cuenta",
      lookupTitle: "Recuperar mi cuenta",
      lookupSubtitle: "Escribe el numero de telefono con el que te registraste y te conectaremos de nuevo.",
      lookupSubmit: "Buscar",
      lookupSubmitting: "Buscando...",
      lookupNotFound: "No encontramos ese numero. Si es la primera vez, registrate abajo.",
      lookupSuccess: "\u00a1Bienvenido de vuelta, {name}!",
      lookupBackToRegister: "Registrarme como nuevo",
      lookupGoToRegister: "Soy nuevo, registrarme",
      meetTitle: "\u00bfNuevo por aqu\u00ed?",
      meetBody: "Conoce a las personas que sirven en Iglesia Nueva Cancion. No necesitas registrarte para verlas.",
      meetCta: "Conoce Nuestra Iglesia",
      backToRegister: "Volver al registro",
    },
    home: {
      greeting: "Bienvenido",
      upcoming: "Eventos y servicios proximos",
      latestNews: "Ultimas noticias",
      emptyEvents: "No hay eventos proximos publicados.",
      emptyNews: "Aun no hay noticias publicadas.",
      viewAll: "Ver todos",
      welcomeCardTitle: "Que bueno verte",
      welcomeCardBody: "Explora las noticias y eventos de la iglesia.",
      installHintTitle: "Instala la app en tu iPhone",
      installHintBody: "Toca Compartir y luego \u2018A\u00f1adir a inicio\u2019 para tenerla siempre a la mano.",
      installDismiss: "Entendido",
      verseRef: "Hebreos 13:8",
      verseText: "Jesucristo es el mismo ayer, hoy y por los siglos.",
      gallerySectionTitle: "Galeria",
      gallerySectionEmpty: "Aun no hay fotos en la galeria.",
      gallerySectionViewAll: "Ver galeria completa",
      dailyVerseTitle: "Versiculo del dia",
      dailyVerseAmen: "Am\u00e9n",
      dailyVerseClose: "Cerrar",
    },
    prayer: {
      pageTitle: "Peticiones de oracion",
      pageSubtitle: "Comparte tu peticion y ora por la familia de la iglesia.",
      submitTitle: "Pedir oracion",
      yourName: "Tu nombre",
      yourRequest: "Tu peticion de oracion",
      yourRequestPlaceholder: "Comparte por que necesitas oracion. Toda la iglesia podra orar por ti.",
      submit: "Publicar peticion",
      submitting: "Publicando...",
      success: "Tu peticion fue publicada. La iglesia orara por ti.",
      requiredAll: "Por favor completa tu nombre y tu peticion.",
      emptyList: "Aun no hay peticiones de oracion. Se el primero en compartir.",
      prayingButton: "Orando por ti",
      prayingButtonShort: "Orando",
      prayedCount: "{n} personas orando",
      prayedCountOne: "1 persona orando",
      commentsLabel: "Comentarios",
      commentInputPlaceholder: "Escribe un comentario de animo...",
      commentSubmit: "Comentar",
      commentSubmitting: "Enviando...",
      noComments: "Aun no hay comentarios.",
      reportAbuse: "Reportar contenido inapropiado",
      momentsAgo: "hace un momento",
    },
    events: {
      title: "Eventos y servicios",
      noEvents: "No hay eventos publicados.",
      detailsTitle: "Detalles del evento",
      tapForDetails: "Toca para ver detalles",
      registerCta: "Registrarse",
      registerHint: "Este evento requiere registro previo. Toca abajo para llenar el formulario.",
      openRegistration: "Abrir registro",
      close: "Cerrar",
      whenLabel: "Cuando",
      whereLabel: "Donde",
      aboutLabel: "Acerca de",
      flyerAlt: "Flyer del evento",
    },
    survey: {
      cardLabel: "Encuesta",
      cardDescription: "Tu opinion fortalecera el ministerio.",
      takeNow: "Tomar ahora",
      pageTitle: "Encuesta",
      backHome: "Volver al inicio",
      loadingHint: "Cargando la encuesta...",
      openInBrowser: "Abrir en el navegador",
      openInBrowserHint: "Si la encuesta no carga aqui, toca el boton para abrirla en tu navegador.",
      thanksHint: "Gracias por tomarte el tiempo.",
    },
    give: {
      title: "Tu ofrenda",
      subtitle: "Apoya el ministerio y los eventos de la iglesia.",
      pickAmount: "Selecciona un monto",
      custom: "Otro monto",
      customPlaceholder: "Ingresa el monto en USD",
      noteLabel: "Nota (opcional)",
      notePlaceholder: "Ej. Para el evento de jovenes",
      donorName: "Tu nombre (opcional)",
      submit: "Dar ahora",
      submitting: "Conectando con Stripe...",
      successTitle: "\u00a1Gracias por tu ofrenda!",
      successBody: "Tu ofrenda fue recibida con exito. Que Dios te bendiga.",
      checking: "Verificando tu pago...",
      failedTitle: "No se pudo confirmar el pago",
      failedBody: "Si el cargo aparece en tu banco, contacta a la iglesia.",
      cancelled: "La ofrenda fue cancelada. Puedes intentarlo de nuevo cuando quieras.",
      backToGive: "Volver a ofrendar",
      backHome: "Ir al inicio",
      amountTooSmall: "El monto minimo es $1.",
      methodPickerTitle: "Elige como ofrendar",
      methodPickerSubtitle: "Dos opciones: pago con tarjeta o transferencia Zelle (sin comision).",
      methodCard: "Tarjeta de credito",
      methodCardSubtitle: "Rapido y seguro \u00b7 procesado por Stripe",
      methodZelle: "Zelle",
      methodZelleSubtitle: "Sin comisiones \u00b7 directo a la iglesia",
      methodZelleBadge: "Recomendado",
      zelleTitle: "Ofrendar por Zelle",
      zelleBody: "Abre la app de tu banco, busca Zelle y envia tu ofrenda al numero o nombre que aparece abajo.",
      zelleSendTo: "Enviar a",
      zelleRegisteredTo: "Registrado como",
      zelleCopy: "Copiar",
      zelleCopied: "Copiado",
      zelleSteps: "Pasos",
      zelleStep1: "Abre la app de tu banco y entra a la seccion Zelle.",
      zelleStep2: "Toca \u2018Enviar\u2019 y escribe el numero de telefono que aparece arriba.",
      zelleStep3: "Confirma que el nombre del destinatario sea \u2018Iglesia Nueva Cancion Lancaster\u2019.",
      zelleStep4: "Escribe el monto y, en la nota, anade tu nombre y proposito (opcional).",
      zelleStep5: "Envia. La iglesia recibira el monto directamente.",
      zelleNoteHeader: "Importante",
      zelleNoteBody: "Zelle es bank-to-bank y la app no puede confirmar el pago automaticamente. Despues de enviar, no es necesario hacer nada mas aqui \u2014 el equipo administrativo registrara tu ofrenda manualmente.",
      backToMethods: "Cambiar metodo",
    },
    gallery: {
      title: "Galeria",
      empty: "Aun no hay fotos. El equipo pastoral las subira pronto.",
      close: "Cerrar",
      allPhotos: "Todas las fotos",
      allPhotosSubtitle: "Ver toda la coleccion",
      albumsHeading: "Albumes",
      backToAlbums: "Volver a albumes",
      photoCount: "{n} foto",
      photoCountPlural: "{n} fotos",
      emptyAlbum: "Este album aun no tiene fotos.",
    },
    social: {
      title: "Conectate con nosotros",
      subtitle: "Siguenos en redes y mantente al tanto de la iglesia.",
      followInstagram: "Seguir en Instagram",
      visit: "Visitar",
      contact: "Contacto",
      address: "Direccion",
      services: "Horarios de servicio",
    },
    common: {
      loading: "Cargando...",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Crear",
      yes: "Si",
      no: "No",
      back: "Atras",
      error: "Algo salio mal. Intenta de nuevo.",
      required: "Requerido",
    },
    admin: {
      title: "Administrador",
      login: "Iniciar sesion",
      emailLabel: "Correo",
      password: "Contrasena",
      loginButton: "Entrar",
      logout: "Salir",
      dashboard: "Panel",
      news: "Noticias",
      events: "Eventos",
      photos: "Fotos",
      members: "Miembros",
      donations: "Ofrendas",
      email: "Correos",
      celebrations: "Celebraciones",
      notifications: "Avisos",
      prayers: "Oracion",
      team: "Conoce",
      survey: "Encuesta",
      accounts: "Administradores",
      settings: "Configuracion",
      welcomeBack: "Bienvenido al panel",
      stats: { members: "Miembros", events: "Eventos", news: "Noticias", donations: "Ofrendas" },
      prayersPage: {
        title: "Peticiones de oracion",
        empty: "No hay peticiones aun.",
        deleteConfirm: "\u00bfEliminar esta peticion y todos sus comentarios?",
        deleteCommentConfirm: "\u00bfEliminar este comentario?",
        prayedLabel: "{n} orando",
        commentsLabel: "{n} comentarios",
        showComments: "Ver comentarios",
        hideComments: "Ocultar comentarios",
        deleted: "Eliminado",
      },
      newsForm: {
        title_es: "Titulo (ES)",
        title_en: "Titulo (EN)",
        body_es: "Contenido (ES)",
        body_en: "Contenido (EN)",
        image: "Volante (imagen)",
        imageHint: "Sube un volante o pega una URL. JPG o PNG, max 8MB.",
        uploadFromDevice: "Subir del telefono",
        pasteUrl: "O pega una URL de imagen",
        uploading: "Subiendo...",
        removeImage: "Quitar imagen",
        invalidImage: "Solo se permiten imagenes",
        tooLarge: "La imagen es muy grande (max 8MB)",
        registrationUrl: "Enlace de registro (opcional)",
        registrationUrlHint: "Si la noticia anuncia algo que requiere inscripcion, pega aqui el enlace (Google Forms, Eventbrite, etc.).",
        sendPushOnCreate: "Enviar notificacion al publicar",
        sendPushOnCreateHint: "Envia una notificacion inmediata a todos los dispositivos suscritos avisando de esta noticia.",
        sendPushButton: "Enviar notificacion",
        sendPushSending: "Enviando...",
        pushAlreadySentBadge: "Notificacion enviada",
        pushNeverSentBadge: "Sin notificar",
        pushSentCount: "Enviada {n} vez",
        pushSentCountPlural: "Enviada {n} veces",
        pushLastSent: "Ultima vez",
        confirmResendTitle: "\u00bfEnviar otra notificacion?",
        confirmResendBody: "Esta noticia ya se envio como notificacion push. \u00bfSeguro que deseas enviarla de nuevo? Los miembros veran una nueva alerta.",
        confirmResendCta: "Si, enviar de nuevo",
        pushSuccess: "Notificacion enviada a {n} dispositivo",
        pushSuccessPlural: "Notificacion enviada a {n} dispositivos",
        // Phase 13 — Scheduled Push for News (Pacific time)
        scheduleLabel: "Programar notificacion (opcional)",
        scheduleHint: "Elige fecha y hora para enviar la notificacion automaticamente. Hora del Pacifico (America/Los_Angeles). Deja vacio para no programar.",
        scheduleTzNote: "Hora del Pacifico (America/Los_Angeles)",
        scheduleClear: "Quitar programacion",
        scheduleTooSoon: "La fecha debe ser al menos 30 segundos en el futuro.",
        scheduleStatusScheduled: "Programada para {when}",
        scheduleStatusSending: "Enviando...",
        scheduleStatusSent: "Enviada",
        scheduleStatusCanceled: "Cancelada",
        scheduleStatusFailed: "Fallo",
        scheduleCanceledOnEdit: "Al guardar sin fecha se cancelara la programacion existente.",
        // Phase 14 — News Push Preview
        previewTitle: "Vista previa (iPhone)",
        previewSubtitle: "Asi se vera en la pantalla de bloqueo",
        previewLangEs: "Espanol",
        previewLangEn: "Ingles",
        previewNow: "ahora",
        previewAppName: "Iglesia Nueva Cancion",
        previewEmptyBody: "El titulo aparecera aqui",
      },
      eventsForm: {
        title_es: "Titulo (ES)",
        title_en: "Titulo (EN)",
        description_es: "Descripcion (ES)",
        description_en: "Descripcion (EN)",
        date: "Fecha",
        time: "Hora",
        location: "Lugar",
        flyer: "Flyer del evento",
        flyerHint: "Sube un flyer (JPG/PNG, max 8MB). Se mostrara en pantalla completa al tocar el evento.",
        flyerUpload: "Subir flyer",
        flyerUploading: "Subiendo...",
        flyerRemove: "Quitar flyer",
        registrationUrl: "Enlace de registro (opcional)",
        registrationUrlHint: "Si el evento necesita inscripcion, pega aqui el enlace (Google Forms, Eventbrite, etc.).",
        recurring: "Repetir cada semana",
        recurringHint: "Envia una notificacion automatica cada semana en el dia y hora que elijas.",
        notifyDay: "Dia de la semana",
        notifyTime: "Hora del aviso",
        dayNames: ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"],
        dayNamesShort: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
        recurringBadge: "Cada semana",
        everyDay: "Cada {day}",
        runNow: "Enviar avisos ahora",
        runNowRunning: "Enviando...",
        runNowResult: "Avisos enviados: {fired} eventos, {sent} entregados, {failed} fallidos.",
      },
      photosForm: {
        file: "Imagen",
        caption_es: "Subtitulo (ES)",
        caption_en: "Subtitulo (EN)",
        upload: "Subir foto",
        album: "Album",
        albumHint: "Cada foto debe pertenecer a un album. Elige o crea uno nuevo desde la pestana Albumes.",
        photosTab: "Fotos",
        albumsTab: "Albumes",
        editPhoto: "Editar foto",
        savePhoto: "Guardar",
        deletePhoto: "Eliminar",
        selectAlbumPlaceholder: "Selecciona un album",
        inAlbum: "En:",
        selectMode: "Seleccionar",
        exitSelect: "Salir",
        selectAll: "Todas",
        clearSelection: "Ninguna",
        selectedCount: "{n} seleccionada",
        selectedCountPlural: "{n} seleccionadas",
        moveTo: "Mover a album",
        moveToPlaceholder: "Elige el album destino",
        moveAction: "Mover",
        bulkMoveSuccess: "{n} foto movida",
        bulkMoveSuccessPlural: "{n} fotos movidas",
        selectionHint: "Toca las fotos para seleccionarlas, luego elige el album destino.",
      },
      albumsForm: {
        pageTitle: "Albumes",
        pageSubtitle: "Organiza las fotos en grupos con nombre bilingue.",
        newAlbum: "Nuevo album",
        editAlbum: "Editar album",
        nameEs: "Nombre (ES)",
        nameEn: "Nombre (EN)",
        descEs: "Descripcion (ES)",
        descEn: "Descripcion (EN)",
        order: "Orden",
        orderHint: "Numero mas bajo = aparece primero.",
        coverAuto: "Portada automatica (foto mas reciente)",
        coverAutoDone: "Portada automatica activada",
        coverPickManual: "Elegir portada especifica",
        create: "Crear album",
        save: "Guardar cambios",
        cancel: "Cancelar",
        delete: "Eliminar album",
        defaultBadge: "Predeterminado",
        confirmDeleteTitle: "Eliminar este album?",
        confirmDeleteBody: "Las fotos del album se moveran al album General. Esta accion no se puede deshacer.",
        confirmDeleteCta: "Si, eliminar",
        photoCount: "{n} foto",
        photoCountPlural: "{n} fotos",
        emptyList: "Aun no hay albumes personalizados. Crea el primero abajo.",
        defaultLocked: "El album predeterminado no se puede eliminar.",
        dragHint: "Arrastra los albumes para cambiar el orden en la galeria. El album General siempre queda primero.",
        reorderSuccess: "Orden guardado",
        dragHandle: "Arrastrar",
      },
      accountsPage: {
        pageTitle: "Administradores",
        pageSubtitle: "Manage quien puede iniciar sesion en /admin.",
        addAdmin: "Agregar administrador",
        ownerBadge: "Dueno",
        adminBadge: "Admin",
        ownerHint: "El dueno se cambia desde las variables de entorno del despliegue.",
        emailLabel: "Correo",
        passwordLabel: "Contrasena",
        confirmPasswordLabel: "Confirmar contrasena",
        labelLabel: "Etiqueta (opcional)",
        labelHint: "Nombre o rol breve, p.ej. \"Pastor Jose\" o \"Ministra de jovenes\".",
        addedAt: "Agregado",
        addedBy: "Agregado por",
        lastLogin: "Ultimo acceso",
        never: "Nunca",
        passwordMin: "Minimo 8 caracteres.",
        passwordMismatch: "Las contrasenas no coinciden.",
        savedToast: "Cambios guardados.",
        createdToast: "Administrador creado.",
        deletedToast: "Administrador eliminado.",
        confirmDelete: "Seguro que quieres eliminar a este administrador? No podra iniciar sesion mas.",
        editTitle: "Editar administrador",
        deleteOwnerWarning: "No puedes eliminar el dueno.",
        cantDeleteSelf: "No puedes eliminar tu propia cuenta mientras esta sesion esta activa.",
        // Change own password section
        changeMyPasswordTitle: "Cambiar mi contrasena",
        changeMyPasswordSub: "Pediremos tu contrasena actual por seguridad.",
        currentPassword: "Contrasena actual",
        newPassword: "Nueva contrasena",
        changePasswordButton: "Cambiar contrasena",
        passwordChanged: "Contrasena actualizada.",
        ownerCantChangePassword: "El dueno cambia su contrasena en el panel de despliegue (variable ADMIN_PASSWORD).",
      },
      settingsForm: {
        churchNameEs: "Nombre iglesia (ES)",
        churchNameEn: "Nombre iglesia (EN)",
        taglineEs: "Lema (ES)",
        taglineEn: "Lema (EN)",
        address: "Direccion",
        phone: "Telefono",
        email: "Correo",
        serviceEs: "Horarios servicio (ES)",
        serviceEn: "Horarios servicio (EN)",
        instagram: "Instagram URL",
        facebook: "Facebook URL",
        youtube: "YouTube URL",
        tiktok: "TikTok URL",
        whatsapp: "WhatsApp URL",
        zelleSection: "Ofrendas Zelle",
        zelleEnabled: "Mostrar Zelle en la app",
        zellePhone: "Telefono Zelle",
        zelleEmail: "Email Zelle (opcional)",
        zelleName: "Nombre registrado",
        zelleInstructionsEs: "Instrucciones extra (ES)",
        zelleInstructionsEn: "Instrucciones extra (EN)",
        stripeSection: "Ofrendas con tarjeta (Stripe)",
        stripeEnabled: "Mostrar tarjeta en la app",
        surveySection: "Encuesta externa (banner)",
        surveyEnabled: "Mostrar banner en Inicio",
        surveyEnabledHint: "Cuando esta activo, todos veran una tarjeta en la pagina principal invitandolos a tomar la encuesta.",
        surveyUrl: "Enlace de la encuesta",
        surveyUrlHint: "Pega aqui la URL completa (QuestionPro, Google Forms, Typeform, etc.).",
        surveyTitleEs: "Titulo (ES)",
        surveyTitleEn: "Titulo (EN)",
        surveyDescriptionEs: "Descripcion (ES)",
        surveyDescriptionEn: "Descripcion (EN)",
        surveyCtaEs: "Texto del boton (ES)",
        surveyCtaEn: "Texto del boton (EN)",
        notificationsSection: "Correo de celebraciones (boletin)",
        notificationRecipients: "Enviar boletin a",
        notificationRecipientsHint: "Correos que recibiran el resumen mensual de cumpleanos y aniversarios. Separa varios con coma. Si dejas vacio, se usa el correo configurado en el despliegue.",
      },
      noItems: "No hay registros aun.",
      addNew: "Agregar",
      confirmDelete: "\u00bfEliminar este elemento?",
      saved: "Guardado",
      deleted: "Eliminado",
      invalidCredentials: "Credenciales invalidas",
      exportCsv: "Exportar CSV",
      celebrationsPage: {
        title: "Celebraciones",
        subtitle: "Cumpleanos y aniversarios de los miembros",
        todayTitle: "Hoy",
        todayEmpty: "No hay celebraciones hoy.",
        monthTitle: "Este mes",
        monthEmpty: "No hay celebraciones este mes.",
        birthdaysHeader: "Cumpleanos",
        anniversariesHeader: "Aniversarios",
        turning: "Cumple",
        years: "anos",
        celebrating: "Celebran",
        anniversaryYears: "anos de matrimonio",
        bannerTitle: "Hoy hay celebraciones",
        bannerBody: "Hay {n} celebraciones de cumpleanos o aniversario hoy.",
        bannerCta: "Ver detalles",
      },
    },
    missedNotification: {
      title: "\u00bfTe perdiste una notificacion?",
      bodyNews: "Toca para ver la noticia.",
      bodyBroadcast: "Toca para ver el aviso de la iglesia.",
      bodyEvent: "Toca para ver el evento.",
      bodyPrayer: "Toca para ver la peticion de oracion.",
      viewCta: "Ver",
      dismissCta: "Descartar",
    },
  },
  en: {
    appName: "Iglesia Nueva Cancion",
    languageName: "English",
    switchTo: "Espanol",
    tagline: "One family, one faith, one new song",
    nav: {
      home: "Home",
      events: "Events",
      give: "Give",
      prayer: "Prayer",
      social: "Social",
      gallery: "Gallery",
    },
    register: {
      title: "Welcome home",
      subtitle: "Before we begin, register as part of our family.",
      fullName: "Full name",
      dob: "Date of birth",
      phone: "Phone number",
      maritalStatus: "Marital status",
      ms: { single: "Single", married: "Married", divorced: "Divorced", widowed: "Widowed" },
      anniversary: "Wedding anniversary",
      submit: "Register",
      submitting: "Registering...",
      privacy: "Your information stays private and is only visible to the pastoral team.",
      success: "Registration completed. Welcome!",
      requiredAll: "Please complete all required fields.",
      alreadyRegistered: "Already registered before?",
      lookupLink: "Recover my account",
      lookupTitle: "Recover my account",
      lookupSubtitle: "Enter the phone number you used to register and we'll sign you back in.",
      lookupSubmit: "Find me",
      lookupSubmitting: "Searching...",
      lookupNotFound: "We couldn't find that number. If this is your first time, please register below.",
      lookupSuccess: "Welcome back, {name}!",
      lookupBackToRegister: "Register as new",
      lookupGoToRegister: "I'm new, register me",
      meetTitle: "New here?",
      meetBody: "Meet the people who serve at Iglesia Nueva Cancion. No sign-up required to view.",
      meetCta: "Meet Our Church",
      backToRegister: "Back to register",
    },
    home: {
      greeting: "Welcome",
      upcoming: "Upcoming events & services",
      latestNews: "Latest news",
      emptyEvents: "No upcoming events posted yet.",
      emptyNews: "No news posted yet.",
      viewAll: "View all",
      welcomeCardTitle: "Good to see you",
      welcomeCardBody: "Explore the church news and events.",
      installHintTitle: "Install on your iPhone",
      installHintBody: "Tap Share, then \u2018Add to Home Screen\u2019 to keep us close.",
      installDismiss: "Got it",
      verseRef: "Hebrews 13:8",
      verseText: "Jesus Christ is the same yesterday, today, and forever.",
      gallerySectionTitle: "Gallery",
      gallerySectionEmpty: "No photos in the gallery yet.",
      gallerySectionViewAll: "View full gallery",
      dailyVerseTitle: "Verse of the day",
      dailyVerseAmen: "Amen",
      dailyVerseClose: "Close",
    },
    prayer: {
      pageTitle: "Prayer requests",
      pageSubtitle: "Share your request and pray for the church family.",
      submitTitle: "Ask for prayer",
      yourName: "Your name",
      yourRequest: "Your prayer request",
      yourRequestPlaceholder: "Share why you need prayer. The whole church can lift you up.",
      submit: "Post request",
      submitting: "Posting...",
      success: "Your request has been posted. The church will pray for you.",
      requiredAll: "Please enter your name and request.",
      emptyList: "No prayer requests yet. Be the first to share.",
      prayingButton: "Praying for you",
      prayingButtonShort: "Praying",
      prayedCount: "{n} praying",
      prayedCountOne: "1 praying",
      commentsLabel: "Comments",
      commentInputPlaceholder: "Write a word of encouragement...",
      commentSubmit: "Comment",
      commentSubmitting: "Sending...",
      noComments: "No comments yet.",
      reportAbuse: "Report inappropriate content",
      momentsAgo: "moments ago",
    },
    events: {
      title: "Events & services",
      noEvents: "No events posted yet.",
      detailsTitle: "Event details",
      tapForDetails: "Tap to see details",
      registerCta: "Register",
      registerHint: "This event requires registration. Tap below to open the form.",
      openRegistration: "Open registration",
      close: "Close",
      whenLabel: "When",
      whereLabel: "Where",
      aboutLabel: "About",
      flyerAlt: "Event flyer",
    },
    survey: {
      cardLabel: "Survey",
      cardDescription: "Your feedback will strengthen our ministry.",
      takeNow: "Take it now",
      pageTitle: "Survey",
      backHome: "Back to home",
      loadingHint: "Loading the survey...",
      openInBrowser: "Open in browser",
      openInBrowserHint: "If the survey doesn't load here, tap the button to open it in your browser.",
      thanksHint: "Thanks for taking the time.",
    },
    give: {
      title: "Your offering",
      subtitle: "Support the ministry and church events.",
      pickAmount: "Choose an amount",
      custom: "Other amount",
      customPlaceholder: "Enter amount in USD",
      noteLabel: "Note (optional)",
      notePlaceholder: "e.g. For youth event",
      donorName: "Your name (optional)",
      submit: "Give now",
      submitting: "Connecting to Stripe...",
      successTitle: "Thank you for your offering!",
      successBody: "Your offering was received. God bless you.",
      checking: "Verifying your payment...",
      failedTitle: "Could not confirm payment",
      failedBody: "If the charge appears on your bank, contact the church.",
      cancelled: "Offering cancelled. You can try again anytime.",
      backToGive: "Back to give",
      backHome: "Go home",
      amountTooSmall: "Minimum amount is $1.",
      methodPickerTitle: "Choose how to give",
      methodPickerSubtitle: "Two options: card payment or Zelle transfer (no fees).",
      methodCard: "Credit card",
      methodCardSubtitle: "Fast and secure \u00b7 processed by Stripe",
      methodZelle: "Zelle",
      methodZelleSubtitle: "No fees \u00b7 direct to the church",
      methodZelleBadge: "Recommended",
      zelleTitle: "Give via Zelle",
      zelleBody: "Open your bank's app, find Zelle, and send your offering to the number or name below.",
      zelleSendTo: "Send to",
      zelleRegisteredTo: "Registered as",
      zelleCopy: "Copy",
      zelleCopied: "Copied",
      zelleSteps: "Steps",
      zelleStep1: "Open your bank's app and find the Zelle section.",
      zelleStep2: "Tap \u2018Send\u2019 and enter the phone number shown above.",
      zelleStep3: "Confirm the recipient name is \u2018Iglesia Nueva Cancion Lancaster\u2019.",
      zelleStep4: "Enter the amount, and in the memo include your name and purpose (optional).",
      zelleStep5: "Send. The church will receive the offering directly.",
      zelleNoteHeader: "Important",
      zelleNoteBody: "Zelle is bank-to-bank and the app cannot confirm payment automatically. After sending you don't need to do anything else here \u2014 the admin team will log your offering manually.",
      backToMethods: "Change method",
    },
    gallery: {
      title: "Gallery",
      empty: "No photos yet. The pastoral team will upload soon.",
      close: "Close",
      allPhotos: "All photos",
      allPhotosSubtitle: "View the full collection",
      albumsHeading: "Albums",
      backToAlbums: "Back to albums",
      photoCount: "{n} photo",
      photoCountPlural: "{n} photos",
      emptyAlbum: "This album has no photos yet.",
    },
    social: {
      title: "Connect with us",
      subtitle: "Follow us and stay close to the church.",
      followInstagram: "Follow on Instagram",
      visit: "Visit",
      contact: "Contact",
      address: "Address",
      services: "Service times",
    },
    common: {
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      yes: "Yes",
      no: "No",
      back: "Back",
      error: "Something went wrong. Please retry.",
      required: "Required",
    },
    admin: {
      title: "Admin",
      login: "Sign in",
      emailLabel: "Email",
      password: "Password",
      loginButton: "Sign in",
      logout: "Sign out",
      dashboard: "Dashboard",
      news: "News",
      events: "Events",
      photos: "Photos",
      members: "Members",
      donations: "Offerings",
      email: "Email",
      celebrations: "Celebrations",
      notifications: "Notifications",
      prayers: "Prayer",
      team: "Our Team",
      survey: "Survey",
      accounts: "Administrators",
      settings: "Settings",
      welcomeBack: "Welcome to your dashboard",
      stats: { members: "Members", events: "Events", news: "News", donations: "Offerings" },
      prayersPage: {
        title: "Prayer requests",
        empty: "No prayer requests yet.",
        deleteConfirm: "Delete this prayer request and all its comments?",
        deleteCommentConfirm: "Delete this comment?",
        prayedLabel: "{n} praying",
        commentsLabel: "{n} comments",
        showComments: "Show comments",
        hideComments: "Hide comments",
        deleted: "Deleted",
      },
      newsForm: {
        title_es: "Title (ES)",
        title_en: "Title (EN)",
        body_es: "Body (ES)",
        body_en: "Body (EN)",
        image: "Flyer (image)",
        imageHint: "Upload a flyer or paste an image URL. JPG or PNG, 8MB max.",
        uploadFromDevice: "Upload from device",
        pasteUrl: "Or paste an image URL",
        uploading: "Uploading...",
        removeImage: "Remove image",
        invalidImage: "Only image files are allowed",
        tooLarge: "Image is too large (max 8MB)",
        registrationUrl: "Registration link (optional)",
        registrationUrlHint: "If the announcement requires sign-up, paste the link here (Google Forms, Eventbrite, etc.).",
        sendPushOnCreate: "Send notification when published",
        sendPushOnCreateHint: "Immediately push a notification to every subscribed device announcing this news item.",
        sendPushButton: "Send notification",
        sendPushSending: "Sending...",
        pushAlreadySentBadge: "Notification sent",
        pushNeverSentBadge: "Not sent",
        pushSentCount: "Sent {n} time",
        pushSentCountPlural: "Sent {n} times",
        pushLastSent: "Last sent",
        confirmResendTitle: "Send another notification?",
        confirmResendBody: "This news item was already sent as a push notification. Are you sure you want to send it again? Members will see a fresh alert.",
        confirmResendCta: "Yes, send again",
        pushSuccess: "Notification delivered to {n} device",
        pushSuccessPlural: "Notification delivered to {n} devices",
        // Phase 13 — Scheduled Push for News (Pacific time)
        scheduleLabel: "Schedule notification (optional)",
        scheduleHint: "Pick a date and time to automatically send the push notification later. Pacific Time (America/Los_Angeles). Leave blank to not schedule.",
        scheduleTzNote: "Pacific Time (America/Los_Angeles)",
        scheduleClear: "Clear schedule",
        scheduleTooSoon: "Time must be at least 30 seconds in the future.",
        scheduleStatusScheduled: "Scheduled for {when}",
        scheduleStatusSending: "Sending...",
        scheduleStatusSent: "Sent",
        scheduleStatusCanceled: "Canceled",
        scheduleStatusFailed: "Failed",
        scheduleCanceledOnEdit: "Saving without a time will cancel the existing schedule.",
        // Phase 14 — News Push Preview
        previewTitle: "Preview (iPhone)",
        previewSubtitle: "This is how it will appear on the lock screen",
        previewLangEs: "Spanish",
        previewLangEn: "English",
        previewNow: "now",
        previewAppName: "Iglesia Nueva Cancion",
        previewEmptyBody: "Your title will appear here",
      },
      eventsForm: {
        title_es: "Title (ES)",
        title_en: "Title (EN)",
        description_es: "Description (ES)",
        description_en: "Description (EN)",
        date: "Date",
        time: "Time",
        location: "Location",
        flyer: "Event flyer",
        flyerHint: "Upload a flyer (JPG/PNG, max 8MB). It'll show full-screen when members tap the event.",
        flyerUpload: "Upload flyer",
        flyerUploading: "Uploading...",
        flyerRemove: "Remove flyer",
        registrationUrl: "Registration link (optional)",
        registrationUrlHint: "If the event needs sign-up, paste the link here (Google Forms, Eventbrite, etc.).",
        recurring: "Repeat weekly",
        recurringHint: "Sends an automatic notification every week on the day and time you choose.",
        notifyDay: "Day of the week",
        notifyTime: "Notification time",
        dayNames: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        dayNamesShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        recurringBadge: "Weekly",
        everyDay: "Every {day}",
        runNow: "Send reminders now",
        runNowRunning: "Sending...",
        runNowResult: "Reminders sent: {fired} events, {sent} delivered, {failed} failed.",
      },
      photosForm: {
        file: "Image",
        caption_es: "Caption (ES)",
        caption_en: "Caption (EN)",
        upload: "Upload photo",
        album: "Album",
        albumHint: "Every photo must belong to an album. Pick one, or create a new album on the Albums tab.",
        photosTab: "Photos",
        albumsTab: "Albums",
        editPhoto: "Edit photo",
        savePhoto: "Save",
        deletePhoto: "Delete",
        selectAlbumPlaceholder: "Select an album",
        inAlbum: "In:",
      },
      albumsForm: {
        pageTitle: "Albums",
        pageSubtitle: "Organize photos into bilingual named groups.",
        newAlbum: "New album",
        editAlbum: "Edit album",
        nameEs: "Name (ES)",
        nameEn: "Name (EN)",
        descEs: "Description (ES)",
        descEn: "Description (EN)",
        order: "Order",
        orderHint: "Lower number = appears earlier.",
        coverAuto: "Auto cover (newest photo)",
        coverAutoDone: "Auto cover enabled",
        coverPickManual: "Pick a specific cover",
        create: "Create album",
        save: "Save changes",
        cancel: "Cancel",
        delete: "Delete album",
        defaultBadge: "Default",
        confirmDeleteTitle: "Delete this album?",
        confirmDeleteBody: "Photos in this album will be moved to the General album. This cannot be undone.",
        confirmDeleteCta: "Yes, delete",
        photoCount: "{n} photo",
        photoCountPlural: "{n} photos",
        emptyList: "No custom albums yet. Create the first one below.",
        defaultLocked: "The default album cannot be deleted.",
      },
      accountsPage: {
        pageTitle: "Administrators",
        pageSubtitle: "Manage who can sign in at /admin.",
        addAdmin: "Add administrator",
        ownerBadge: "Owner",
        adminBadge: "Admin",
        ownerHint: "The Owner is set via the deployment environment variables.",
        emailLabel: "Email",
        passwordLabel: "Password",
        confirmPasswordLabel: "Confirm password",
        labelLabel: "Label (optional)",
        labelHint: "Short name or role, e.g. \"Pastor Jose\" or \"Youth minister\".",
        addedAt: "Added",
        addedBy: "Added by",
        lastLogin: "Last sign-in",
        never: "Never",
        passwordMin: "At least 8 characters.",
        passwordMismatch: "Passwords don't match.",
        savedToast: "Changes saved.",
        createdToast: "Administrator created.",
        deletedToast: "Administrator removed.",
        confirmDelete: "Are you sure you want to remove this administrator? They will no longer be able to sign in.",
        editTitle: "Edit administrator",
        deleteOwnerWarning: "You can't remove the Owner.",
        cantDeleteSelf: "You can't delete your own account while signed in.",
        changeMyPasswordTitle: "Change my password",
        changeMyPasswordSub: "We'll ask for your current password for security.",
        currentPassword: "Current password",
        newPassword: "New password",
        changePasswordButton: "Change password",
        passwordChanged: "Password updated.",
        ownerCantChangePassword: "The Owner changes their password via the deployment dashboard (ADMIN_PASSWORD variable).",
      },
      settingsForm: {
        churchNameEs: "Church name (ES)",
        churchNameEn: "Church name (EN)",
        taglineEs: "Tagline (ES)",
        taglineEn: "Tagline (EN)",
        address: "Address",
        phone: "Phone",
        email: "Email",
        serviceEs: "Service times (ES)",
        serviceEn: "Service times (EN)",
        instagram: "Instagram URL",
        facebook: "Facebook URL",
        youtube: "YouTube URL",
        tiktok: "TikTok URL",
        whatsapp: "WhatsApp URL",
        zelleSection: "Zelle offerings",
        zelleEnabled: "Show Zelle in the app",
        zellePhone: "Zelle phone",
        zelleEmail: "Zelle email (optional)",
        zelleName: "Registered name",
        zelleInstructionsEs: "Extra instructions (ES)",
        zelleInstructionsEn: "Extra instructions (EN)",
        stripeSection: "Card offerings (Stripe)",
        stripeEnabled: "Show card in the app",
        surveySection: "External survey (home banner)",
        surveyEnabled: "Show banner on Home",
        surveyEnabledHint: "When ON, everyone sees a card on the home page inviting them to take the survey.",
        surveyUrl: "Survey link",
        surveyUrlHint: "Paste the full URL (QuestionPro, Google Forms, Typeform, etc.).",
        surveyTitleEs: "Title (ES)",
        surveyTitleEn: "Title (EN)",
        surveyDescriptionEs: "Description (ES)",
        surveyDescriptionEn: "Description (EN)",
        surveyCtaEs: "Button label (ES)",
        surveyCtaEn: "Button label (EN)",
        notificationsSection: "Celebrations digest email",
        notificationRecipients: "Send digest to",
        notificationRecipientsHint: "Email addresses that receive the monthly birthday & anniversary digest. Separate multiple with commas. Leave empty to use the deployment default.",
      },
      noItems: "No records yet.",
      addNew: "Add",
      confirmDelete: "Delete this item?",
      saved: "Saved",
      deleted: "Deleted",
      invalidCredentials: "Invalid credentials",
      exportCsv: "Export CSV",
      celebrationsPage: {
        title: "Celebrations",
        subtitle: "Member birthdays and anniversaries",
        todayTitle: "Today",
        todayEmpty: "No celebrations today.",
        monthTitle: "This month",
        monthEmpty: "No celebrations this month.",
        birthdaysHeader: "Birthdays",
        anniversariesHeader: "Anniversaries",
        turning: "Turning",
        years: "years old",
        celebrating: "Celebrating",
        anniversaryYears: "years of marriage",
        bannerTitle: "Celebrations today",
        bannerBody: "There are {n} birthdays or anniversaries to celebrate today.",
        bannerCta: "See details",
      },
    },
    missedNotification: {
      title: "Did you miss a notification?",
      bodyNews: "Tap to open the news announcement.",
      bodyBroadcast: "Tap to open the church broadcast.",
      bodyEvent: "Tap to open the event details.",
      bodyPrayer: "Tap to open the prayer request.",
      viewCta: "View",
      dismissCta: "Dismiss",
    },
  },
};
